import { useTranslation } from 'react-i18next';
import styles from './CardTag.module.less';
import { Tag, Typography } from 'antd';
import React from 'react';
import i18next from '../../i18next';
import classnames from 'classnames';
import { primaryColor } from '../../styles/theme';

type TagProps = {
  className?: string;
  text?: string;
};
export const CardTag = (props: TagProps) => {
  const { className, text } = props;
  const { t } = useTranslation();

  return (
    <div className={classnames(styles.tag, className)} data-testid="defaultTag">
      <Typography.Text>{text || t('general.default')}</Typography.Text>
    </div>
  );
};

export const CardTagDefault = () => <Tag color={primaryColor}>{i18next.t('general.default')}</Tag>;
export const CardTagSecondary = () => <Tag>{i18next.t('general.secondary')}</Tag>;
